import { render, staticRenderFns } from "./NewReleasesView.vue?vue&type=template&id=fb3c0c66"
import script from "./NewReleasesView.vue?vue&type=script&lang=ts"
export * from "./NewReleasesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports